import axiosPrivate from './axiosPrivate';

const getAreas = () => {
  return axiosPrivate.get('practicantes-requerimientos/areas').then((r) => r.data);
};

const listar = (params = {}) => {
  return axiosPrivate.get('practicantes-requerimientos', { params }).then((r) => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('practicantes-requerimientos', payload).then((r) => r.data);
};

const actualizar = (payload) => {
  return axiosPrivate.put('practicantes-requerimientos', payload).then((r) => r.data);
};

const avanzar = (id_requerimiento) => {
  return axiosPrivate.post('practicantes-requerimientos/avanzar', { id_requerimiento }).then((r) => r.data);
};

const subirCarta = (id_requerimiento, archivo, fecha_inicio_practica, fecha_fin_practica) => {
  const fd = new FormData();
  fd.append('id_requerimiento', id_requerimiento);
  fd.append('carta', archivo);
  fd.append('fecha_inicio_practica', fecha_inicio_practica);
  fd.append('fecha_fin_practica', fecha_fin_practica);
  return axiosPrivate.post('practicantes-requerimientos/carta', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export default {
  getAreas,
  listar,
  crear,
  actualizar,
  avanzar,
  subirCarta,
};
